import React, { useEffect, useState } from "react";
import "./CohortCard.scss";
import { useDispatch, useSelector } from "react-redux";
import exportimages from "../../../../assets/images/exportImages";
import { DeleteCohortModel } from "./DeleteCohortModel";
import { usePermissions } from "../../../../hooks/usePermissions";
import { useSubscription } from "../../../../hooks/useSubscription";
import { PRIVILEGES } from "../../../../utils/privileges";
import { setCohortApplied } from "../../../../rtk-query/features/cohort/cohortSlice";
const CohortCard = ({
  uid,
  title,
  subtitle,
  range,
  institutions,
  avg,
  percentile,
  isDeletable,
}) => {
  const dispatch = useDispatch();
  const { hasPermission } = usePermissions();
  const { hasSubscription } = useSubscription();
  const [showDeleteButton, setShowDeleteButton] = useState(false);
  const [showDeleteCohortModel, setShowShowDeleteCohortModel] = useState(false);
  const selectedCohort = useSelector(
    (state) => state?.cohortReducer?.selectedCohort,
  );

  return (
    <>
      <div
        className={`cohort-card cursor-pointer ${uid === selectedCohort?.uid ? "active" : ""}`}
        onMouseEnter={() => setShowDeleteButton(true)}
        onMouseLeave={() => setShowDeleteButton(false)}
      >
        <div className="top-section">
          <h4>{title}</h4>
          <p>{subtitle}</p>
          <div className="range">{range}</div>
          {hasPermission(PRIVILEGES.DELETE_COHORT) &&
            hasSubscription(PRIVILEGES.DELETE_COHORT) &&
            isDeletable && (
              <div
                className={`delete-icon ${showDeleteButton ? "show" : ""}`}
                onClick={() => setShowShowDeleteCohortModel(true)}
              >
                <img
                  alt="icon"
                  src={
                    uid === selectedCohort?.uid
                      ? exportimages.list_icon_delete_white
                      : exportimages.list_icon_delete
                  }
                />
              </div>
            )}
        </div>
        <div className="bottom-section">
          <div className="stats">
            <div>
              <label>Institutions</label>
              <span>{institutions}</span>
            </div>
            <div>
              <label>Cohort Average</label>
              <span>{avg}</span>
            </div>
            <div>
              <label>Percentile</label>
              <span>{percentile}</span>
            </div>
          </div>
        </div>
      </div>
      <DeleteCohortModel
        show={showDeleteCohortModel}
        onHide={() => setShowShowDeleteCohortModel(false)}
        uid={uid}
      />
    </>
  );
};

export default CohortCard;
